import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const LINKS = [
  { name: "Nosotros",  to: "/nosotros",  external: false },
  { name: "Productos", to: "/productos", external: false },
  { name: "Ventajas",  to: "/ventajas",  external: false },
  { name: "Ubicación", to: "/ubicacion", external: false },
  { name: "WhatsApp",  to: "https://wa.me/542236901020", external: true },
];

function FooterLogo() {
  return (
    <svg width="36" height="32" viewBox="0 0 80 70" fill="none">
      <path d="M5 65 L5 20 Q5 5 20 5 L38 5 Q46 5 46 15 L46 65"
        stroke="#c9973a" strokeWidth="7" fill="none" strokeLinecap="round"/>
      <path d="M46 65 L46 15 Q46 5 54 5 L62 5 Q75 5 75 20 L75 65"
        stroke="#c9973a" strokeWidth="7" fill="none" strokeLinecap="round"/>
      <rect x="14" y="22" width="22" height="16" rx="1" fill="#8b6220" fillOpacity="0.5"/>
      <line x1="25" y1="22" x2="25" y2="38" stroke="#c9973a" strokeWidth="1.5"/>
      <line x1="14" y1="30" x2="36" y2="30" stroke="#c9973a" strokeWidth="1.5"/>
      <rect x="52" y="22" width="16" height="16" rx="1" fill="#8b6220" fillOpacity="0.5"/>
      <line x1="60" y1="22" x2="60" y2="38" stroke="#c9973a" strokeWidth="1.5"/>
      <line x1="52" y1="30" x2="68" y2="30" stroke="#c9973a" strokeWidth="1.5"/>
    </svg>
  );
}

const linkStyle = {
  fontFamily: "'Jost', sans-serif",
  fontSize: "0.72rem",
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#6b6257",
  textDecoration: "none",
  transition: "color 0.3s",
  cursor: "none",
};

export default function Footer() {
  return (
    <footer style={{
      background: "#0a0907",
      borderTop: "1px solid rgba(201,151,58,0.12)",
      padding: "3rem 0",
      textAlign: "center",
    }}>
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.75rem", marginBottom: "1rem" }}
      >
        <FooterLogo />
        <span style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "1.1rem", fontWeight: 600, letterSpacing: "0.15em",
          background: "linear-gradient(135deg, #f0c96b, #c9973a)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}>
          Monaco Aberturas
        </span>
      </motion.div>

      <p style={{
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.7rem", letterSpacing: "0.35em",
        textTransform: "uppercase", color: "#6b6257",
        marginBottom: "2rem",
      }}>
        Soluciones de Vanguardia · Santa Clara del Mar
      </p>

      {/* Links */}
      <ul style={{
        display: "flex", flexWrap: "wrap", gap: "2.5rem",
        justifyContent: "center", listStyle: "none",
        margin: "0 0 2rem", padding: 0,
      }}>
        {LINKS.map((link) => (
          <li key={link.name}>
            {link.external ? (
              <a href={link.to} target="_blank" rel="noreferrer"
                style={linkStyle}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#f0c96b"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "#6b6257"; }}>
                {link.name}
              </a>
            ) : (
              <Link to={link.to} style={linkStyle}
                onMouseEnter={(e) => { e.currentTarget.style.color = "#f0c96b"; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = "#6b6257"; }}>
                {link.name}
              </Link>
            )}
          </li>
        ))}
      </ul>

      {/* Gold separator */}
      <div style={{ width: 96, height: 1, background: "rgba(201,151,58,0.15)", margin: "0 auto 1.5rem" }} />

      <p style={{
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.7rem", letterSpacing: "0.1em",
        color: "rgba(107,98,87,0.5)",
      }}>
        © {new Date().getFullYear()} Monaco Aberturas. Todos los derechos reservados. ·{" "}
        Santa Clara del Mar, Buenos Aires, Argentina
      </p>
    </footer>
  );
}